import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {getProducts} from "../api/HomeApi";
import Loading from "../../../layouts/Loading";
import {MdOutlineLocalOffer} from "react-icons/md";
import {TiChevronLeftOutline} from "react-icons/ti";
import {TbSquareRoundedMinus, TbSquareRoundedPlusFilled} from "react-icons/tb";
import { useCart } from '../../../context/CartContext';
import {showError} from "../../../utils/toastHelper";

const Products = () => {
    const [products, setProducts] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const currencyFormat = Intl.NumberFormat('en-US');

    const { onPlusClick, onMinusClick, getItemCartCount } = useCart();

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const params = {
                    count: 4,
                    special: true,
                    list: 1,
                    vendor: localStorage.getItem('_vid')
                }
                const data = await getProducts(params);
                setProducts(data?.data || []);
            } catch (err) {
                 showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);

    if (loading) return <Loading />;

    return (
        <section className="container  mt-3 rtl px-0  ">
            <div className="row mx-1">
                <div className="col-8 home-separator-text ">
                    <MdOutlineLocalOffer className='mx-2'/>

                    پیشنهاد ویژه
                </div>
                <div className="col-4 text-start text-small-3 text-secondary-color mt-1"

                     onClick={() => navigate('/products?special=1')}
                >
                    مشاهده همه
                    <TiChevronLeftOutline className='mx-1'/>
                </div>
            </div>
            <div className="row ms-3 me-2 pb-5 mb-3">
                {
                    products.map((product, index) => {
                        if (product.inventory < 1 && config.shopping_app_settings.show_no_inventory === '0') {
                            return '';
                        }
                        return (

                            <div className="col-6 col-md-3 px-0 mt-0"

                                 key={product.id}
                            >
                                <div className="row vendor-product m-1">
                                    <div className="col-12 text-center mt-3"
                                         onClick={
                                             () => {
                                                 navigate(`/product/${product.id}`)

                                             }
                                         }
                                    >
                                        {
                                            product.vendor_price?.discount_percent > 0 &&
                                            <div className='discount-percent'>
                                                    <span
                                                        className='badge badge-info badge-pill bg-third-color  text-small-3'>
                                                    {product?.vendor_price?.discount_percent}
                                                        &nbsp;

                                                        %

                                                </span>
                                            </div>
                                        }
                                        <div className="clearfix"></div>
                                        <img src={product.image} alt={product.name} className='w-50'/>

                                    </div>
                                    <div className="col-12 text-center text-small-2" onClick={
                                        () => {
                                            navigate(`/product/${product.id}`)
                                        }
                                    }>
                                        {product.name.substring(0, 30)}
                                    </div>

                                    <div className="col-12 ">
                                        {product.vendor_price?.price ?
                                            <div className=" text-start mt-4 mb-2 text-muted fw-bold text-small-1">

                                                {
                                                    product.vendor_price?.discount_percent > 0 ?
                                                        <div
                                                            className='text-decoration-line-through fw-normal text-small-3 opacity-50 '>
                                                            {currencyFormat.format(product.vendor_price?.price)}
                                                            &nbsp;
                                                            {config.currency}
                                                        </div> :
                                                        <div
                                                            className='text-decoration-line-through fw-normal text-small-3 opacity-50'>
                                                            &nbsp;
                                                        </div>

                                                }

                                                <div>
                                                    {currencyFormat.format(product.vendor_price?.discounted_price)}
                                                    &nbsp;
                                                    <span className='text-small-3 text-muted'>
                                                            {config.currency}
                                                    </span>
                                                </div>


                                            </div>
                                            : ''
                                        }
                                    </div>

                                    {
                                        config.shopping_app_settings.show_plus_minus > 0 &&

                                        <div className={
                                            getItemCartCount(product.id) > 0 ? "add-minus-products text-center mt-0 pt-0 bg-custom rounded" : "add-minus-products text-center mt-0 pt-0"
                                        }>

                                            {

                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="add-product-icon text-secondary "
                                                          onClick={() => {
                                                              onMinusClick(product.id, product.minimum_purchase);

                                                          }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="px-2" onClick={
                                                        () => {
                                                            /* setShowCountBox(true)
                                                             setCountIndex(index)
                                                             setCountId(product.id)
                                                             setCountPrice(product.price)
                                                             setTheCount(getItemCartCount(product.id))*/
                                                        }
                                                    }>
                                    <input type="tel" className="bg-white" value={getItemCartCount(product.id)}
                                           readOnly/>
                                </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                (product.inventory > 0 || config.shopping_app_settings.ignore_inventory > 0) ?
                                                    <span className="add-product-icon   "
                                                          onClick={() => {
                                                              onPlusClick(product.id, product.price, product.inventory,product.minimum_purchase, product.maximum_purchase )

                                                          }}>
                                         <TbSquareRoundedPlusFilled className='text-primary-color'/>
                                    </span>
                                                    :
                                                    <span className='text-danger text-small-2'>
                                                            ناموجود
                                                        </span>
                                            }

                                        </div>
                                    }


                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </section>
    );
};

export default Products;